import { isly } from "isly";
export var Numeric;
(function (Numeric) {
    var _a;
    Numeric.values = [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
    ];
    _a = isly
        .number("value", ...Numeric.values)
        .rename("isoly.Date.Day.Numeric")
        .bind(), Numeric.type = _a.type, Numeric.is = _a.is, Numeric.flawed = _a.flawed;
    function parse(value) {
        return Numeric.type.get(Number.parseInt(value));
    }
    Numeric.parse = parse;
})(Numeric || (Numeric = {}));
//# sourceMappingURL=Numeric.js.map